<p-toolbar id="app-header" styleClass="app-header" [class.sidebar-expanded]="!isSidebarCollapsed">
    <div class="p-toolbar-group-left screen-lg" role="region" aria-label="Welcome Message">
        @if (currentUser) {
            <h5 id="header-welcome-message">
                {{ welcomeMessage | translate }},
                <span id="header-user-first-name">{{ currentUser.firstName ? currentUser.firstName : null }}!</span>
            </h5>
        }
        @if (currentGroup && currentGroup.id !== noGroup.id) {
            <a class="group-container" tooltipFocusHandler [routerLink]="redirectSettingsUrl">
                <i class="fa-solid fa-pipe"></i>
                <i class="fa-light fa-users"></i>
                <app-ellipsis-tooltip [isElementFocusable]="false" [paragraphId]="'header-user-group-container'">
                    {{ currentGroup.name }}
                </app-ellipsis-tooltip>
            </a>
        }
    </div>

    <div class="p-toolbar-group-left screen-sm">
        <div id="sidebar-header-logo">
            <a [routerLink]="appRoutes.routes().DASHBOARD">
                <img
                    width="40"
                    height="40"
                    [ngSrc]="'assets/images/app-logo.svg'"
                    id="app-logo"
                    [alt]="'img.alt.goToDashboard' | translate" />
            </a>
            <div>
                <p id="app-title-header">{{ 'sequencing' | translate }}</p>
                <p id="app-subtitle-header">{{ 'transnetyx' | translate }}</p>
            </div>
        </div>
    </div>

    <div class="p-toolbar-group-right">
        <app-toolbar></app-toolbar>
    </div>
</p-toolbar>
